import userReducer from './redux/reducers/userSlice'
import { configureStore } from '@reduxjs/toolkit';

export const Store = configureStore({
  reducer: {
    user: userReducer,
  },
});
